const formatRupiah  = (x) => {
  x = Math.floor(x);
  let formatted = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return "Rp " + formatted;
}

export default formatRupiah;